import { createSlice, PayloadAction, createAction } from '@reduxjs/toolkit';
import { IState } from 'shared/interfaces/state.interface';
import { TPaginationRequest } from 'shared/types';
import { initialStore } from '../initial-store';

export const createSubscription = createAction(
  'subscription/CREATE_SUBSCRIPTION',
  (payload) => ({ payload })
);

export const updateSubscription = createAction(
  'subscription/UPDATE_SUBSCRIPTION',
  (payload) => ({ payload })
);

export const cancelSubscription = createAction(
  'subscription/CANCEL_SUBSCRIPTION',
  (payload) => ({ payload })
);

const subscriptionSlice = createSlice({
  name: 'subscription',
  initialState: initialStore.subscription,
  reducers: {
    setSubscriptionData: (state, { payload }) => {
      state.dataSubscriptions = payload || {};
      state.isLoading = false;
    },
    getSubscriptionData: (
      state,
      data: PayloadAction<TPaginationRequest | undefined>
    ) => {
      if (!state.isLoading) {
        state.isLoading = true;
      }
    },
    actionFail: (state) => {
      state.isLoading = false;
      state.dataIndividualSubscription.isLoadingUpdate = false;
    },
    buildSubscriptionPage: (state, { payload }) => {
      state.isLoading = true;
    },
    setIndividualSubscriptionInfo: (state, { payload }) => {
      const data = payload || {};
      state.dataIndividualSubscription.data = {
        ...data
      };
      state.isLoading = false;
    },
    setSubscription: (state, { payload }) => {
      state.dataIndividualSubscription.data = {
        ...payload
      };
      state.isLoading = false;
    },
    createSubscriptionSuccess: (state) => {
      state.isLoading = false;
    },
    updateSubscriptionSuccess: (state) => {
      state.isLoading = false;
    },
    cancelSubscriptionSuccess: (state) => {
      state.isLoading = false;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(createSubscription, (state) => {
        state.isLoading = true;
      })
      .addCase(updateSubscription, (state) => {
        state.isLoading = true;
      })
      .addCase(cancelSubscription, (state) => {
        state.isLoading = true;
      });
  }
});

export const {
  setSubscriptionData,
  getSubscriptionData,
  actionFail,
  buildSubscriptionPage,
  setIndividualSubscriptionInfo,
  setSubscription,
  createSubscriptionSuccess,
  updateSubscriptionSuccess,
  cancelSubscriptionSuccess
} = subscriptionSlice.actions;

export const { reducer } = subscriptionSlice;

// Selectors
export const getSubscriptionsSelector = (state: IState) =>
  state && state?.subscription?.dataSubscriptions;

export const getSubscriptionsLoadingSelector = (state: IState) =>
  state && state?.subscription?.isLoading;

export const getSubscriptionsLoadingUpdateSelector = (state: IState) =>
  state && state?.subscription?.dataIndividualSubscription?.isLoadingUpdate;

export const getSubscriptionIndividualSelector = (state: IState) =>
  state && {
    data: state.subscription.dataIndividualSubscription?.data
  };

export const getSubscriptionCount = (state: IState) =>
  state && state?.subscription?.dataSubscriptions?.count;
